import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "../Features/Cart/cartSlice";
import wishListSlice from "../Features/Wishlist/wishListSlice";
import productsSlice from "../Features/Products/productsSlice";
import ordersSlice from "../Features/Orders/ordersSlice";
import authSlice from "../Features/Auth/authSlice";
import rouletteSlice from "../Features/Roulette/rouletteSlice";
import siteModeSlice from "../Features/SiteMode/siteModeSlice";

const store = configureStore({
  reducer: {
    cart: cartSlice,
    wishlist: wishListSlice,
    products: productsSlice,
    orders: ordersSlice,
    auth: authSlice,
    roulette: rouletteSlice,
    siteMode: siteModeSlice,
  },
});

export default store;
